import { Component } from "react";
import { graphql } from "gatsby";
import { extract } from "@parksandresorts/core";
import styles from "./iframe-block.module.less";

export default class IframeBlock extends Component {
  constructor(props) {
    super(props);
    this.iframeTitle = extract(props, "iframeTitle", "");
    this.iframeUrl = extract(props, "iframeUrl", "");
    this.cssInlineStyle = extract(props, "css.childMarkdownRemark.rawMarkdownBody", "");
    this.iframeParentClasses = extract(props, "iframeParentClasses", "");
    this.iframeClasses = extract(props, "iframeClasses", "");
  }

  render() {
    return (
      this.iframeUrl && (
        <section
          className={[this.iframeParentClasses, styles.iframeWrapper].join(" ")}
          data-contentful-id={this.props.contentful_id}
        >
          <iframe
            title={this.iframeTitle}
            className={this.iframeClasses ? this.iframeClasses : ""}
            src={this.iframeUrl}
          ></iframe>
          {this.cssInlineStyle && <style>{this.cssInlineStyle}</style>}
        </section>
      )
    );
  }
}

export const fragmentIframeBlock = graphql`
  fragment IframeBlock on ContentfulIframeBlock {
    contentful_id
    id
    iframeTitle
    iframeUrl
    iframeParentClasses
    iframeClasses
    css {
      childMarkdownRemark {
        rawMarkdownBody
      }
    }
  }
`;
